/**
 * @deprecated Use TokenActionHUD instead. This is a thin wrapper for backward compatibility.
 */
import React from "react";
import type { TokenAction } from "@roll1/shared";
import TokenActionHUD from "./TokenActionHUD";

interface TokenActionBarProps {
  actions: TokenAction[];
  onAction: (action: TokenAction) => void;
  tokenScreenPos?: { x: number; y: number };
  tokenSize?: number;
}

const TokenActionBar = React.memo(function TokenActionBar({
  actions,
  onAction,
  tokenScreenPos,
  tokenSize,
}: TokenActionBarProps) {
  if (actions.length === 0) return null;

  return (
    <TokenActionHUD
      actions={actions}
      onAction={onAction}
      tokenScreenPos={tokenScreenPos ?? { x: 0, y: 0 }}
      tokenSize={tokenSize ?? 0}
      viewportWidth={window.innerWidth}
      viewportHeight={window.innerHeight}
    />
  );
});
export default TokenActionBar;
